module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.74f69ef5.woff";